import { ButtonCSSStyleImpl } from '../../../toolkit/button/buttoncss';
import { Colors } from '../../../../utils/resources/colors';


export class DisabledButtonCSSStyleImpl extends ButtonCSSStyleImpl
{ 
    getButtonStyle(): object 
    {
       return {
        width:'100%',
        height: '40px',
        float: 'left', 
        borderRadius: '3px',
        overflow: 'hidden',
        backgroundColor: this.getResources().getColor(Colors.color_19),
        cursor: "pointer",
        border: 'none',
        alignContent: 'center',
        alignItems: "center",
        justifyContent: "center",
        outline:'none'

           
      };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/doityourself/buttoncss.tsx